import Env from "../../base/env";
import imagesLoaded from "imagesloaded";
import Channels from "../../base/channels";
import "babel-polyfill";

class Launcher {
  constructor() {
    // Dom
    this.view = Env.$launcher;
    this.$canvas = this.view.querySelector(".canvas");
    // Vars
    this.viewport = Env.framework.toolbox.getViewport();
    // Pixi
    this.renderer = new PIXI.autoDetectRenderer({
      width: this.viewport.width,
      height: this.viewport.height,
      transparent: true,
      antialias: true,
    });
    this.stage = new PIXI.Container();
    this.ticker = new PIXI.ticker.Ticker();
    this.spriteLogo = config.pathAssets + "/img/logo_new.png";
    this.dMapSprite = manifestImg.dMapLauncher;
    this.settings = {
      width: 378,
      height: 99,
    };
    if (Env.mobileCSS) {
      this.settings = {
        width: this.settings.width / 2.5,
        height: this.settings.height / 2.5,
      };
    }
    // Tweens
    this.tlIn = new TimelineLite();
    this.tlOut = new TimelineLite();
    // Preload
    this.imgsToPreload = [];
    // Flags
    this.TOTAL_PRELOAD = this.imgsToPreload.length;
    this.NO_INTRO = false;
    this.LAUNCHED = false;
    this.SPEED = 5;
    // FNs
    this.setup();
  }

  completeIn() {
    setTimeout(() => {
      this.out();
    }, 1000);
  }

  completeOut() {
    this.ticker.destroy();
    this.renderer.destroy();
    Env.$html.classList.add("ui--isReady");
    this.LAUNCHED = true;
    Env.$master.removeChild(this.view);
  }

  drawLogo() {
    // Sprite
    this.sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(this.spriteLogo));
    this.sprite.anchor.set(0.5);
    this.sprite.width = this.settings.width;
    this.sprite.height = this.settings.height;
    if (Env.mobileCSS === true) {
      const angle = Env.framework.toolbox.degreeToRadian(-90);
      this.sprite.rotation = angle;
    }
    this.sprite.position.x = this.renderer.width / 2;
    this.sprite.position.y = this.renderer.height / 2;
    this.sprite.alpha = 0;

    //Dmap
    this.displacementSprite = new PIXI.Sprite.fromImage(this.dMapSprite);
    this.displacementSprite.texture.baseTexture.wrapMode =
      PIXI.WRAP_MODES.REPEAT;
    this.displacementSprite.anchor.set(0.5);
    this.displacementSprite.x = 0;
    this.displacementSprite.y = 0;
    this.displacementSprite.scale.x = 1;
    this.displacementSprite.scale.y = 1;
    this.displacementFilter = new PIXI.filters.DisplacementFilter(
      this.displacementSprite
    );
    this.displacementFilter.scale.x = 0;
    this.displacementFilter.scale.y = 0;
    this.displacementFilter.autoFit = false;
    this.stage.filters = [this.displacementFilter];

    // Apply
    this.stage.addChild(this.displacementSprite);
    this.stage.addChild(this.sprite);
  }

  enter() {
    this.tlIn.add([
      TweenLite.fromTo(
        this.sprite,
        1,
        { alpha: 0 },
        { alpha: 1, ease: Cubic.easeInOut }
      ),
      TweenLite.fromTo(
        this.displacementSprite,
        1,
        { x: 80, y: 50 },
        { x: 80, y: 0, ease: Cubic.easeOut, delay: 0.1 }
      ),
      TweenLite.fromTo(
        this.displacementFilter.scale,
        1,
        { x: 40, y: 10 },
        { x: 0, y: 0, ease: Cubic.easeOut, delay: 0.1 }
      ),
    ]);
    this.tlIn.add(() => {
      this.completeIn();
    });
  }

  makeCanvas() {
    this.$canvas.appendChild(this.renderer.view);
    this.drawLogo();
    this.render();
    this.start();
  }

  noLaunch() {
    Env.$html.classList.add("ui--isReady");
    Env.$master.removeChild(this.view);
    setTimeout(() => {
      Channels.emit("launcher::exit");
      this.LAUNCHED = true;
    }, 100);
  }

  out() {
    const getCurrentController = Env.framework.toolbox.getController();
    this.tlOut.add([
      TweenLite.fromTo(
        this.displacementSprite,
        1.5,
        { x: 160, y: 0 },
        { x: 160, y: 100, ease: Cubic.easeInOut }
      ),
      TweenLite.fromTo(
        this.displacementFilter.scale,
        1.5,
        { x: 0, y: 0 },
        { x: 40, y: 10, ease: Cubic.easeInOut }
      ),
    ]);
    this.tlOut.add(
      [
        TweenLite.fromTo(
          this.sprite,
          1,
          { alpha: 1 },
          { alpha: 0, ease: Cubic.easeOut }
        ),
        TweenLite.to(this.view, 1, {
          opacity: 0,
          ease: Sine.easeOut,
          onStart: () => {
            if (getCurrentController === "home") {
              setTimeout(() => {
                Channels.emit("launcher::exit");
              }, 200);
            }
          },
        }),
      ],
      "-=1"
    );
    this.tlOut.add(() => {
      if (getCurrentController !== "home") {
        Channels.emit("launcher::exit");
      }
      this.completeOut();
    });
  }

  preload() {
    var array = Object.values(manifestImg);
    // Create Img
    for (let i = 0; i < array.length; i++) {
      const img = document.createElement("img");
      img.setAttribute("src", array[i]);
      this.imgsToPreload.push(img);
    }
  }

  render() {
    this.ticker.add((delta) => {
      this.renderer.render(this.stage);
    });
  }

  setup() {
    Env.framework.toolbox.resetScroll();
    this.preload();
    if (this.NO_INTRO) {
      this.noLaunch();
    } else {
      this.makeCanvas();
      setTimeout(() => {
        this.enter();
      }, 500);
    }
  }

  start() {
    this.ticker.start();
  }

  stop() {
    this.ticker.stop();
  }
}

export default Launcher;
